import axios from "axios";
import { APP_CONFIG } from "./config";
import { clearSession, getAuthToken } from "./utils/session";

const axiosInstance = axios.create({
  baseURL: APP_CONFIG.apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const isSessionExpiredError = (error) => {
  const status = error.response?.status;
  const message = String(error.response?.data?.message || "").toLowerCase();

  return (
    status === 401 ||
    message.includes("jwt expired") ||
    message.includes("token expirado") ||
    message.includes("sesión caducada") ||
    message.includes("sesion caducada") ||
    message.includes("session expired")
  );
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isSessionExpiredError(error)) {
      clearSession();

      if (!window.sessionExpiredEventEmitted) {
        window.sessionExpiredEventEmitted = true;
        window.dispatchEvent(
          new CustomEvent("sessionExpired", {
            detail: {
              message:
                "El tiempo de la sesión activa ha caducado. Por seguridad, inicia sesión de nuevo.",
            },
          })
        );
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
